import { handleLongText } from 'config/libraries';
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom';

export const List = ({response}) => {
    return (
        <Fragment>
            {
                response && response.map((item, index) => {
                    return (
                        <div key={index} className="col-md-12 jl_grid_layout1 blog_grid_post_style post-2957 post type-post status-publish format-standard has-post-thumbnail hentry category-inspiration tag-morning">
                            <div className="jl_grid_w">
                                <div className="text-box">
                                    <h3>
                                        <a href={process.env.REACT_APP_SERVER_IMAGE_URL + item.file_dokumen} target="_blank" rel='noreferrer' tabIndex={-1}>{item.judul_dokumen}</a>
                                    </h3>
                                    <span className="jl_post_meta">
                                        <span className="jl_author_img_w">
                                        <span className="post-date">
                                                <i className="jli-pen" />Diunduh: {item.total_diunduh} kali
                                            </span>
                                            <span className="post-date">
                                                <i className="jli-pen" />{item.created_at}
                                            </span>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    )
                })
            }
        </Fragment>
    )
};